import { Injectable } from "@angular/core";

import { Observable, of } from "rxjs";

import { LocalStorage } from "@dffedb/util";
import { AppserverInstallationCredentialsRepository } from "@e-forsyning/common/credentials";

import { Opgave, opgaveVersion } from "../opgave/model/opgave.model";
import { OpgaveMapper } from "./opgave.mapper";

@Injectable({ providedIn: "root" })
export class OpgaveLocalstorageService {
    constructor(
        private readonly credentials: AppserverInstallationCredentialsRepository,
        private readonly mapper: OpgaveMapper,
        private readonly localStorage: LocalStorage
    ) {}

    public hentOpgave(opgaveId: number): Observable<Opgave> {
        let dbOpgave = this.hentOpgaver()[opgaveId];
        if (!dbOpgave) {
            return of(null);
        }

        dbOpgave = this.opgraderOpgaveTilNyesteVersion(dbOpgave);

        const result$ = this.mapper.dtoToOpgave(dbOpgave);
        return result$;
    }

    public gemOpgave(opgave: Opgave): void {
        const dbOpgave = this.mapper.opgaveToDto(opgave);
        const opgaver = this.hentOpgaver();
        opgaver[opgave.id] = dbOpgave;
        this.gemOpgaver(opgaver);
    }

    public sletOpgave(opgaveId: number): void {
        const opgaver = this.hentOpgaver();
        delete opgaver[opgaveId];
        this.gemOpgaver(opgaver);
    }

    private hentOpgaver(): any {
        const info = this.credentials.hent();
        const key = `${info.ejendomNr}-${info.installationNr}`;
        const resultAsString = this.localStorage.getItem(`servicerapporter[${key}]`) || null;
        return JSON.parse(resultAsString) || {};
    }

    private gemOpgaver(opgaver: {}): void {
        const info = this.credentials.hent();
        const key = `${info.ejendomNr}-${info.installationNr}`;
        const asString = JSON.stringify(opgaver);
        this.localStorage.setItem(`servicerapporter[${key}]`, asString);
    }

    private opgraderOpgaveTilNyesteVersion(opgave: Opgave): Opgave {
        opgave.installation = opgave.installation || { ejendomNr: 0, installationNr: 0 };

        // Hvis vi laver breaking changes i opgave-strukturen, bør vi løfte this.version til et
        // højere nummer og i denne rutine foretage opgradering f.eks.fra version 1 til version 2.
        if (opgave.version === 1) {
            // I version 1 gemte vi ServicerapportOpgave.
            // Fra version 2 gemmer vi i samme udgave som sendes til AppServeren.
            opgave = this.mapper.opgaveToDto(opgave);
            opgave.version = 2;
        }

        if (opgave.version !== opgaveVersion) {
            throw new Error(`Opgaven har version '${opgave.version}'. Den forventede version er '${opgaveVersion}'.`);
        }

        return opgave;
    }
}
